<template>
  <!--商品详情-->
  <div id="product-detail">
    <!--图片-->
    <div class="main-img">
      <img :src=baseUrl width="320" height="320">
    </div>
    <!--文字-->
    <div class="img-content">
      <div class="img-content-title">
        <a href="#">{{keyConfig.cupType?keyConfig.cupType.beverage.name:keyConfig.name}} {{keyConfig.cupType?keyConfig.cupType.cupSize==null?'':keyConfig.cupType.cupSize.name:''}}</a>
      </div>
      <div class="price" v-if="!isFree">
        <span class="ng-binding">¥ {{keyConfig.price}}</span>
      </div>
    </div>
    <div class="bottom-pay"  v-if="wxAppId!='a'||isAlipay" @click="payNow">{{keyConfig.price == 0?'立即打杯':'立即支付'}}</div>
    <div class="bottom-nopay" v-if="wxAppId=='a'&&isWx" >{{keyConfig.price == 0?'立即打杯':'立即支付'}}</div>
  </div>
</template>

<script>
import {productList,getOpenId,addOrder,wxPay,getKeyConfig,aliPay,getAppId,produceBeverageByOrder} from "@/api/productApi";
import {jsSDK} from '../api/jsSDK.js'
import {getUrlParam} from "../utils/commonUtil";
import md5 from 'js-md5';
import {GetSignature} from "../api/common";
import wx from 'weixin-js-sdk';
import {checkSource, generateOrderNo} from "../utils/productUtil";

let _this;
export default {
  name: "ProductDetailForQRCode",
  data(){
    return{
      dtuNo: '',
      wxAppId : 'a',
      isFree:false,//是否是免费
      // free:0,
      // 订单信息
      order:new Object(),
      orderData:{},
      isWx:true,// 是否是微信支付
      isAlipay:false,
      code:'',// 微信的code
      openId:'',// 将openId作为本地参数储存,
      currentTime:'',
      keyConfig:{
        cupType:{
          beverage:{
            name:"",
            picture:new Object()
          }
        },
        price:0
      },
      free:0,
      baseUrl:'https://icloud.lhcoffeetime.com',
      tempUrl:''
    }
  },
  mounted() {
    var element = document.createElement("script");
    element.src = "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js";
    document.body.appendChild(element);
    this.free = getUrlParam('free')
     if(this.free == 1){
       this.isFree = true
     }else{
       this.isFree =false
    }
    this.initData();
  },
  methods:{
      initData(){
        this.$forceUpdate()
        if(getUrlParam('dtuNo')){
          this.dtuNo = getUrlParam('dtuNo')
        }else if(this.$route.query.dtuNo){
          this.dtuNo = this.$route.query.dtuNo
        }else{
          alert('dtu编号获取失败！')
          return
        }
        let keyConfigSort
        if(getUrlParam('sort')){
          keyConfigSort = getUrlParam('sort')
        }else if(this.$route.query.sort){
          keyConfigSort = this.$route.query.sort
        }else{
          alert('sort排序获取失败！')
          return
        }
          let source = checkSource();
      //source = 2
      if(source == -1){
        alert('非支付宝和微信扫码')
        return
      }else if(source == 1){
        this.isWx = true
        this.isAlipay = false
      }else if(source == 2){
        this.isWx = false
        this.isAlipay = true
      }

        getKeyConfig({sort:keyConfigSort,dtuNo:this.dtuNo}).then(res=>{
            if(res.code==200){
                this.keyConfig = res.data;
                let tempUrl = this.keyConfig.cupType?this.keyConfig.cupType.beverage.picture.path:this.keyConfig.fileLib?this.keyConfig.fileLib.path:null
                this.baseUrl = 'https://icloud.lhcoffeetime.com' + tempUrl
                //alert(res.data.id)
                if(this.free==0){
                  this.isFree = res.data.price==0?true:false
                }
                this.order = {
                  orderStatus:0, // 0,1,2,3不知道什么意思
                  remark:'', // 备注
                  totalAmount:res.data.price, // 原价
                  actualAmount:res.data.price,// 扣除优惠券以后的金额
                  cupTypeID:res.data.cupTypeID, // 杯型ID
                  keyConfig_ID:res.data.id,
                  dtuNo:this.dtuNo, // free:element.price>0?false:true,
                  orderTime:'',
                  title:res.data.cupType?res.data.cupType.beverage.name+' '+(res.data.cupType.cupSize?res.data.cupType.cupSize.name:''):res.data.name
                }
                if(!this.isFree){
                  getAppId({dtuNo:this.dtuNo}).then(res=>{
                      if(res.code==200){
                          this.wxAppId = res.data.wxAppId;
                          this.getWxAuth()
                      }else{
                          alert(res.msg);
                      }
                  });
                }
            }else{
                alert(res.code);
            }
        })

    },
    // 进入页面的时候进行授权操作
    getWxAuth(){
      this.code = getUrlParam('code')

      if(this.isWx) {
        if(this.openId == null || this.openId == '' || this.openId == undefined){
          if (this.code == null || this.code == '' || this.code == undefined) {
            //const url = 'http://127.0.0.1:8080/#/productDetailTouch?dtuNo='+this.dtuNo+'&sort='+this.keyConfig.sort
            //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx22ef96392ef45c31&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            const url = 'https://icloud.lhcoffeetime.com/pages/payment/index.html?dtuNo='+this.dtuNo+'&sort='+this.keyConfig.sort+'#/productDetailTouch';
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.wxAppId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
          }
        }
      }
    },
    // 立即支付
    // TODO 不知道为什么promise和await都没起作用,后期看看
    payNow(){
      let that = this
      that.reloading = this.openLoading()

      // 如果是微信，且openid为空
      //this.code = getUrlParam('code')
      if(this.isFree){
        this.order.free = true
        this.order.payMode = 0
        // this.payMode = 0
      }else{
        this.order.free = false
        if(this.isWx){
          // this.payMode = 1
          this.order.payMode = 1
        }else if(this.isAlipay){
          // this.payMode = 2
          this.order.payMode = 2
        }
      }

      let orderData = {} // 临时对象
      this.getCurrentTime()
      this.order.orderTime = this.currentTime
      this.order.orderForm = 0
      if(this.isFree){
        let orderNo = generateOrderNo()
        this.order.orderNo = orderNo
        this.order.orderNo = orderNo
      }
      // 生成订单
      addOrder(this.order).then(res=>{
        if(res.code==200){
          //区分是否是免费模式
          if(this.isFree){
            let param = {
              orderNo:res.data.orderNo
            }
            let orderNo = res.data.orderNo;
            let orderForm = res.data.orderForm;
            produceBeverageByOrder(param).then(res=>{
              if(res.code==200){
                // this.$router.push({name:'Product',params:{dtuNo:this.dtuNo}})
                window.location.href = 'https://icloud.lhcoffeetime.com/pages/payment/index.html/#/cupsuccess?orderNo='+orderNo+'&orderFrom='+orderForm
              }
            })
          }else {
            // 区分支付宝还是微信
            if (this.isWx) {
              orderData.orderNo = res.data.orderNo;
              orderData.total_fee = res.data.actualAmount;
              orderData.body = res.data.cupType?res.data.cupType.beverage.name:'';
              if (this.openId) {
                orderData.openId = this.openId
                orderData.apiType = 'JSAPI'
                wxPay(orderData).then(res => {
                  //这个对象用来调起支付接口
                   if(res.code==200){
                      let tempData = {
                        appId: res.data.appid,
                        timeStamp: res.data.timestamp,
                        nonceStr: res.data.noncestr,
                        package: 'prepay_id=' + res.data.prepayid,
                        signType: 'MD5',
                        paySign: res.data.sign,
                        key: res.data.key,
                        //另外的参数，用于支付结束后获取订单信息
                        orderNo: orderData.orderNo
                      }
                     _this.rechargeWx(tempData)
                   }
                })
              } else {
                // 获取openid
                let param = {
                  appId: this.wxAppId,
                  code: this.code,
                  dtuNo: this.dtuNo
                }
                getOpenId(param).then(res => {
                  if(res.code==200){
                    orderData.openId = res.data.wxOpenId
                    this.openId = res.data.wxOpenId
                    orderData.apiType = 'JSAPI'
                    wxPay(orderData).then(ress => {
                      if(ress.code==200){
                        //这个对象用来调起支付接口
                        let tempData = {
                          appId: ress.data.appid,
                          timeStamp: ress.data.timestamp,
                          nonceStr: ress.data.noncestr,
                          package: 'prepay_id=' + ress.data.prepayid,
                          signType: 'MD5',
                          paySign: ress.data.sign,
                          key: ress.data.key,
                          //另外的参数，用于支付结束后获取订单信息
                          orderNo: orderData.orderNo
                        }
                        _this.rechargeWx(tempData)
                      }
                    })
                  }

                })
              }

            } else {
                // 支付宝支付
                orderData.orderNo = res.data.orderNo
                orderData.body = res.data.cupType?res.data.cupType.beverage.name:'';
              aliPay(orderData).then(res=>{
                      const div = document.createElement('div');
                      div.innerHTML = res.data;
                      document.body.appendChild(div);
                      document.forms[0].submit();
                  // ap.tradePay({
                  //   orderStr: res.data
                  // }, function(res){
                  //  // ap.alert(res.resultCode);
                  //   if(res.resultCode ==9000){
                  //     var orderFrom = 0;

                  //     //window.location.href = 'https://icloud.lhcoffeetime.com/pages/payment/index.html?orderNo='+orderData.orderNo+'&orderFrom='+orderFrom+'#/alisuccess'
                  //   }
                  // });
                })
            }
          }
        }else{
          alert(res.msg)
        }
      })
      },
      // 调起微信支付
      rechargeWx (params) {
        let strTemp = 'appId='+params.appId+'&nonceStr='+params.nonceStr+'&package='+params.package+'&signType='+params.signType+'&timeStamp='+params.timeStamp
        let str = strTemp+'&key='+params.key;
        let sign = md5(str).toUpperCase().substr(0, 32);
        let data = {
          appId: params.appId,
          nonceStr: params.nonceStr,
          package: params.package,
          signType: params.signType,
          timeStamp: params.timeStamp,
          paySign: sign
        }
        jsSDK(data,params.orderNo,0,this.dtuNo);
      },
      getCurrentTime() {
        //获取当前时间并打印
    　　let yy = new Date().getFullYear();
    　　let mm = new Date().getMonth()+1;
    　　let dd = new Date().getDate();
    　　let hh = new Date().getHours();
    　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    　　this.currentTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
      }
    },


  created() {
    _this = this

  }
}
</script>

<style lang="less">
  #product-detail{
    width: 100vw;
    height: 100vh;
    background-color: #F5F5F5;
    min-width: 320px;
    max-width: 800px;
    margin: auto;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    .main-img{
      width:100%;
      height:84vh;
    }
    .img-content{
      background-color: #FFFFFF;
      font-size: 14px;
      text-align: left;
      padding: .6em;
      height: 7vh;
      .img-content-title{
        a{
          background: 0 0;
          color: #000000;
          text-decoration: none;
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: .2em;
        }
      }
      .price{
        margin-top: .3rem;
        font-size: .8em;
        color: #fd4648;
        margin-bottom: 0;
        .ng-binding{
          font-size: 16px;
        }
      }
    }
    .bottom-pay{
      width: 100%;
      height: 7vh;
      background-color: #4169E1;
      line-height: 3rem;
      color: #FFFFFF;
      font-size: 18px;
      bottom: 0;
      position: absolute;
    }
    .bottom-nopay{
      width: 100%;
      height: 7vh;
      background-color: #5f6063;
      line-height: 3rem;
      color: #FFFFFF;
      font-size: 18px;
      bottom: 0;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductDetailTouch.vue